var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g, _path33, _path34, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg24Hr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 215,
    viewBox: "0 0 209 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.0311 24.7598H78.6562V36.8112H97.0311V24.7598Z",
    fill: "#B3BFCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0311 24.7598H78.6562V29.7994H97.0311V24.7598Z",
    fill: "#9FADBF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4687 48.644L17.4062 58.7234L24.6249 65.9542L34.6874 55.8749L27.4687 48.644Z",
    fill: "#B3BFCF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M143.842 55.2175L153.904 65.2969L160.467 58.7234L150.404 48.644L143.842 55.2175Z",
    fill: "#B3BFCF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6224 214.734C143.403 214.734 182.997 175.074 182.997 126.211C182.997 77.3482 143.403 37.9072 94.6224 37.9072C45.8415 37.9072 6.24805 77.5673 6.24805 126.43C6.24805 175.293 45.8415 214.734 94.6224 214.734Z",
    fill: "#D3DAE6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3743 211.448C138.155 211.448 177.749 171.787 177.749 122.924C177.749 74.0615 138.155 34.4014 89.3743 34.4014C40.5935 34.4014 1 74.2806 1 123.144C1 172.007 40.5935 211.448 89.3743 211.448Z",
    fill: "#DAE1ED",
    stroke: "#D3DAE6",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 127.965C9.31249 127.965 7.5625 126.212 7.5625 124.02C7.5625 123.582 7.5625 123.144 7.5625 122.925C7.5625 81.731 38.1873 46.8914 79.0932 41.6326C81.2807 41.4135 83.2494 42.9473 83.4682 45.1385C83.6869 47.3297 82.1557 49.3017 79.9682 49.5208C42.9997 54.1223 15.2187 85.8942 15.2187 122.925C15.2187 123.363 15.2187 123.582 15.2187 124.02C15.2187 126.212 13.4687 127.965 11.5 127.965Z",
    fill: "#EDF0FC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3745 205.093C80.6245 205.093 71.8746 203.778 63.7809 200.93C61.5934 200.272 60.4997 198.081 61.1559 196.109C61.8122 193.918 63.9997 192.822 65.9684 193.48C73.4058 196.109 81.2808 197.205 89.1557 197.205C126.124 197.205 157.624 169.596 162.655 132.784C162.874 130.593 164.843 129.06 167.03 129.279C169.218 129.498 170.749 131.47 170.53 133.661C167.905 153.162 158.28 171.13 143.624 184.277C128.53 197.862 109.281 205.093 89.3745 205.093Z",
    fill: "#C8D3DE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M158.28 123.143C158.28 124.02 158.28 124.677 158.28 125.553C156.968 162.584 126.78 192.165 89.3745 192.165C51.9685 192.165 21.5625 162.365 20.4688 125.334C20.4688 124.458 20.4688 123.801 20.4688 122.924C20.4688 85.6742 49.9998 55.217 86.7495 53.9023C87.6245 53.9023 88.4995 53.9023 89.3745 53.9023C127.218 53.9023 157.624 84.1404 158.28 121.609C158.28 122.267 158.28 122.705 158.28 123.143Z",
    fill: "#EDF0FC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M158.28 125.335C156.968 162.365 126.78 191.946 89.3745 191.946C51.9685 191.946 21.5625 162.365 20.4688 125.335C21.7812 88.3041 51.9685 58.7234 89.3745 58.7234C126.562 58.5043 156.968 88.3041 158.28 125.335Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M107.75 167.186H68.375C66.4062 167.186 64.875 165.652 64.875 163.68V143.959C64.875 141.987 66.4062 140.454 68.375 140.454H107.75C109.718 140.454 111.25 141.987 111.25 143.959V163.68C111.031 165.652 109.5 167.186 107.75 167.186Z",
    fill: "#F2F5FC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M149.092 126.43H137.717C135.748 126.43 134.217 124.896 134.217 122.924C134.217 120.952 135.748 119.418 137.717 119.418H149.092C151.06 119.418 152.592 120.952 152.592 122.924C152.373 124.896 150.842 126.43 149.092 126.43Z",
    fill: "#DAE1ED"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5311 126.43H26.1562C24.1875 126.43 22.6562 124.896 22.6562 122.924C22.6562 120.952 24.1875 119.418 26.1562 119.418H37.5311C39.4999 119.418 41.0311 120.952 41.0311 122.924C40.8124 124.896 39.0624 126.43 37.5311 126.43Z",
    fill: "#DAE1ED"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M87.625 188.221C85.6562 188.221 84.125 186.687 84.125 184.715V173.321C84.125 171.349 85.6562 169.815 87.625 169.815C89.5937 169.815 91.1249 171.349 91.1249 173.321V184.715C90.9062 186.687 89.375 188.221 87.625 188.221Z",
    fill: "#DAE1ED"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M87.625 76.4718C85.6562 76.4718 84.125 74.938 84.125 72.966V61.791C84.125 59.819 85.6562 58.2852 87.625 58.2852C89.5937 58.2852 91.1249 59.819 91.1249 61.791V73.1851C90.9062 74.938 89.375 76.4718 87.625 76.4718Z",
    fill: "#DAE1ED"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4999 132.565C94.1874 132.565 98.9998 127.964 98.9998 122.048C98.9998 116.132 94.4061 111.53 88.4999 111.53C82.8125 111.53 78 116.132 78 122.048C78 127.964 82.5937 132.565 88.4999 132.565Z",
    fill: "#F2F5FC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M132.904 80.6352C131.591 79.5396 129.623 79.5396 128.529 80.6352L91.5605 119.419C91.3417 119.419 91.3417 119.419 91.123 119.419C88.2792 119.419 86.3105 121.61 86.3105 124.239C86.3105 124.458 86.3105 124.678 86.3105 124.897L80.4043 131.032C79.3105 132.347 79.3105 134.319 80.4043 135.414C81.0605 136.072 81.7168 136.291 82.5918 136.291C83.4668 136.291 84.3418 136.072 84.7793 135.414L90.6855 129.279C90.9042 129.279 91.123 129.279 91.123 129.279C93.9667 129.279 95.9354 127.088 95.9354 124.458C95.9354 124.239 95.9354 124.02 95.9354 123.801L132.904 85.2366C134.216 83.4837 134.216 81.5116 132.904 80.6352Z",
    fill: "#DAE1ED"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M130.062 78.2245C128.75 77.1289 126.781 77.1289 125.687 78.2245L88.9374 117.008C88.7187 117.008 88.7187 117.008 88.4999 117.008C85.6562 117.008 83.6875 119.199 83.6875 121.829C83.6875 122.048 83.6875 122.267 83.6875 122.486L77.7812 128.621C76.6875 129.936 76.6875 131.908 77.7812 133.004C78.4375 133.661 79.0937 133.88 79.9687 133.88C80.8437 133.88 81.7187 133.661 82.1562 133.004L88.0624 126.868C88.2812 126.868 88.4999 126.868 88.4999 126.868C91.3436 126.868 93.3124 124.677 93.3124 122.048C93.3124 121.829 93.3124 121.61 93.3124 121.39L130.281 82.826C131.375 81.2921 131.156 79.3201 130.062 78.2245Z",
    fill: "#06C167"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M128.748 79.3202L78.6545 131.689C78.217 131.689 78.217 131.689 77.7795 131.689C77.342 131.032 77.5607 130.155 77.9982 129.498L126.123 78.882C126.779 78.2246 127.873 78.2246 128.529 78.6628C128.967 78.6628 128.967 79.1011 128.748 79.3202Z",
    fill: "#ADDEC9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M105.781 7.88819V19.5014C105.781 23.8837 102.062 27.3896 97.906 27.3896H78.2187C73.8437 27.3896 70.3438 23.6646 70.3438 19.5014V7.88819C70.3438 3.50586 74.0625 0 78.2187 0H97.906C102.281 0 105.781 3.72498 105.781 7.88819Z",
    fill: "#1C3754"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M105.781 7.88819V19.5014C105.781 23.8837 102.062 27.3896 97.906 27.3896H78.2187C73.8437 27.3896 70.3438 23.6646 70.3438 19.5014V17.3102C71.6562 22.7881 76.4687 22.7881 76.4687 22.7881H96.8123C99.656 22.7881 101.844 20.3778 101.844 17.7484V9.42201C101.844 3.72498 100.75 1.53382 97.6873 0C102.281 0 105.781 3.72498 105.781 7.88819Z",
    fill: "#172D45"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4043 20.8162C72.748 20.8162 72.3105 20.378 72.3105 19.7206V6.57361C72.3105 5.91626 72.748 5.47803 73.4043 5.47803C74.0605 5.47803 74.498 5.91626 74.498 6.57361V19.7206C74.0605 20.378 73.623 20.8162 73.4043 20.8162Z",
    fill: "#2D5887"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2187 20.8162C77.5625 20.8162 77.125 20.378 77.125 19.7206V6.57361C77.125 5.91626 77.5625 5.47803 78.2187 5.47803C78.875 5.47803 79.3125 5.91626 79.3125 6.57361V19.7206C79.3125 20.378 78.875 20.8162 78.2187 20.8162Z",
    fill: "#2D5887"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M83.248 20.8162C82.5918 20.8162 82.1543 20.378 82.1543 19.7206V6.57361C82.1543 5.91626 82.5918 5.47803 83.248 5.47803C83.9043 5.47803 84.3418 5.91626 84.3418 6.57361V19.7206C84.123 20.378 83.6855 20.8162 83.248 20.8162Z",
    fill: "#2D5887"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2812 20.8162C87.625 20.8162 87.1875 20.378 87.1875 19.7206V6.57361C87.1875 5.91626 87.625 5.47803 88.2812 5.47803C88.9375 5.47803 89.375 5.91626 89.375 6.57361V19.7206C89.375 20.378 88.9375 20.8162 88.2812 20.8162Z",
    fill: "#2D5887"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3105 20.8162C92.6543 20.8162 92.2168 20.378 92.2168 19.7206V6.57361C92.2168 5.91626 92.6543 5.47803 93.3105 5.47803C93.9668 5.47803 94.4043 5.91626 94.4043 6.57361V19.7206C94.1855 20.378 93.748 20.8162 93.3105 20.8162Z",
    fill: "#2D5887"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3418 20.8162C97.6855 20.8162 97.248 20.378 97.248 19.7206V6.57361C97.248 5.91626 97.6855 5.47803 98.3418 5.47803C98.998 5.47803 99.4355 5.91626 99.4355 6.57361V19.7206C99.4355 20.378 98.7793 20.8162 98.3418 20.8162Z",
    fill: "#2D5887"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M103.154 20.8162C102.498 20.8162 102.061 20.378 102.061 19.7206V6.57361C102.061 5.91626 102.498 5.47803 103.154 5.47803C103.811 5.47803 104.248 5.91626 104.248 6.57361V19.7206C104.248 20.378 103.811 20.8162 103.154 20.8162Z",
    fill: "#2D5887"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4353 49.5201L18.7167 60.2568C16.3104 62.6671 12.5917 62.6671 9.96673 60.2568L3.84178 54.1216C1.43555 51.7113 1.43555 47.9863 3.84178 45.3569L14.5605 34.6202C16.9667 32.2099 20.6854 32.2099 23.3104 34.6202L29.4353 40.7555C31.6228 43.3849 31.6228 47.329 29.4353 49.5201Z",
    fill: "#1C3754"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M148.436 49.5201L159.154 60.2568C161.56 62.6671 165.279 62.6671 167.904 60.2568L174.029 54.1216C176.435 51.7113 176.435 47.9863 174.029 45.3569L163.31 34.6202C160.904 32.2099 157.185 32.2099 154.56 34.6202L148.436 40.7555C146.029 43.3849 146.029 47.329 148.436 49.5201Z",
    fill: "#1C3754"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M88.498 122.924C88.9355 122.924 89.373 122.486 89.373 122.048C89.373 121.61 88.9355 121.171 88.498 121.171C88.0605 121.171 87.623 121.61 87.623 122.048C87.623 122.486 88.0605 122.924 88.498 122.924Z",
    fill: "#1C3754"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M158.279 122.048H86.9668V54.1216C87.8418 54.1216 88.7168 54.1216 89.5918 54.1216C126.998 54.1216 157.623 84.3597 158.279 122.048Z",
    fill: "url(#paint0_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.653 175.753C199.434 176.629 199.216 177.506 198.997 178.382C198.341 181.012 197.466 183.641 196.153 186.051C195.934 186.49 195.715 187.147 195.497 187.586C195.497 187.805 195.278 188.023 195.278 188.023C191.34 195.692 185.434 202.047 178.434 206.648C177.559 207.306 176.684 207.744 175.809 208.182C175.372 208.402 174.715 208.84 174.059 209.059C172.966 209.497 171.872 210.155 170.778 210.593C167.716 211.908 164.435 212.784 161.153 213.441C155.028 214.537 148.466 214.756 142.122 213.222C115.873 207.744 99.0285 182.108 104.497 155.814C109.966 129.52 135.56 112.647 161.81 118.125C170.997 120.097 179.528 124.699 186.309 131.272C198.122 143.105 203.153 159.757 199.653 175.753Z",
    fill: "#29C969"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M129.625 181.647V175.074L141 162.803C142.094 161.488 142.531 160.831 142.531 159.516C142.531 157.763 141.656 156.668 139.687 156.668C138.375 156.668 136.844 157.325 136.844 159.735H129.625C129.625 153.6 134.219 150.313 139.687 150.313C145.375 150.313 149.75 153.819 149.75 159.735C149.75 163.022 148.437 164.775 145.812 167.405L138.375 175.293H149.75V181.866H129.625V181.647Z",
    fill: "url(#paint1_linear)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M172.5 177.484V181.647H165.719V177.484H152.812V170.691L163.094 150.313H170.969L160.687 170.691H165.719V166.528H172.5V170.691H174.906V177.484H172.5Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 95.4668,
    y: 114.093,
    width: 113.278,
    height: 113.224,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.1125 0 0 0 0 0.295916 0 0 0 0 1 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 82.0458,
    y1: 67.6056,
    x2: 145.838,
    y2: 131.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06C167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 164.204,
    y1: 188.939,
    x2: 129.06,
    y2: 159.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0113208,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 190.774,
    y1: 188.671,
    x2: 155.415,
    y2: 156.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0113208,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg24Hr);
export default __webpack_public_path__ + "static/media/24hr.8c8a4a78.svg";
export { ForwardRef as ReactComponent };